import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig";
import AOPPrev from "./AOPPrev";
import { AOPSwitzerlandInvoiceData } from "@/src/types/admissionOffice";

const emptyInvoiceState = (): AOPSwitzerlandInvoiceData => ({
  currentDate: "",
  fullName: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  dateOfBirth: "",
  passport_number: "",
  academicYear: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  invoiceBody: [],
  yearOfStudy: "",
  yearStudyMode: "",
});

const AOPInvoiceLetterSwissLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPSwitzerlandInvoiceData>(emptyInvoiceState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPSwitzerlandInvoiceData>(emptyInvoiceState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPInvoiceLetterSwissLayout;
